// SPDX-FileCopyrightText: © 2023 Schneider Electric
//
// SPDX-License-Identifier: LGPL-2.1-only

import { unescape } from "lodash-es";

export const resizeObserver = (callback: () => void): ResizeObserver =>
  new ResizeObserver((entries) => {
    // We wrap it in requestAnimationFrame to avoid this error - ResizeObserver loop limit exceeded.
    window.requestAnimationFrame(() => {
      if (!Array.isArray(entries) || entries.length === 0) {
        return;
      }
      callback();
    });
  });

export const isNumber = (number: number | string): boolean =>
  Number.isInteger(number) || /^\d*$/.test(number as string);

export const isTouchDevice = (): boolean =>
  "ontouchstart" in window || navigator.maxTouchPoints > 0;

export const parseValue = (valueToParse: string): string[] | undefined => {
  try {
    return JSON.parse(unescape(valueToParse)) as string[];
  } catch {
    if (valueToParse.split(";").length > 0) return valueToParse.split(";");
    // eslint-disable-next-line no-console
    console.error(
      "Couldn't JSON parse. Stringify the object or use `;` to separate different values if the object is a list of strings",
    );
    return undefined;
  }
};
